const EllipsisListItem = ({ title }) => {
  const width = 190;
  return (
    <span className="d-inline-block ellipsis" title={title} style={{ width }}>
      {title}
    </span>
  );
};

export default EllipsisListItem;
